import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { toVw, toVwMobile, toVwTablet } from '../../../utils/styles';
import StyledLink from '../../../components/StyledLink';
import mq from '@/utils/media-queries';

const MARGIN_BOTTOM = 18;

const NameLink = styled(StyledLink)`
  margin-bottom: ${toVw(MARGIN_BOTTOM)};
  display: inline-block;

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(MARGIN_BOTTOM)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(MARGIN_BOTTOM)};
  `)};
`;

const Description = styled.div`
  margin-bottom: ${toVw(MARGIN_BOTTOM)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(MARGIN_BOTTOM)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(MARGIN_BOTTOM)};
  `)};
`;

const Location = styled.div`
  color: ${props => props.theme.colorMinor};
`;

const Vacancy = ({ className, id, name, description, city }) => (
  <div className={className} data-test="jobs-vacancy">
    <NameLink to={`/ru/jobs/${id}/`} data-test="vacancy-link">
      {name}
    </NameLink>
    <Description>{description}</Description>
    <Location>{city}</Location>
  </div>
);

Vacancy.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
};

export default Vacancy;



// WEBPACK FOOTER //
// ./src/scenes/Jobs/components/Vacancy.js